// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4248) return "css/4248-402aca15.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"7563":"40040828","8665":"8a1e1514"}[chunkId] + ".css";
};